import { Entity, EntityStringId, IEntityType, IIdentifiableEntity } from 'app/types/entity';
import vmClient from 'app/services/vmClient';
import { SiteFeature, SiteFeatureMarshaller } from 'app/constants/enums/SiteFeature';
import { Configuration, IConfiguration } from './Configuration';

export interface IOrganizationSiteFeature extends IIdentifiableEntity {
  attributes: {
    id: EntityStringId;
    siteFeature: SiteFeature;
  };
  associations: {
    configuration: IConfiguration | null;
  }
}

export type OrganizationSiteFeature = Entity<IOrganizationSiteFeature>;
// eslint-disable-next-line @typescript-eslint/no-redeclare
export const OrganizationSiteFeature: IEntityType<IOrganizationSiteFeature> = vmClient.defineClass({
  typeName: 'OrganizationSiteFeature',
  version: 1,
  persisted: true,
  attributes: {
    siteFeature: {
      type: SiteFeature,
      marshaller: SiteFeatureMarshaller,
      notNull: true,
    },
  },
  associations: {
    configuration: Configuration,
  },
});
